import { IN_APP_HELP_COMPONENT, CALLING_COMPONENT, CALLING_REMOTE_COMPONENT_ID, IN_APP_HELP_COMPONENT_ID } from 'navigation-components/config';
export const componentIds = {
  [IN_APP_HELP_COMPONENT]: IN_APP_HELP_COMPONENT_ID,
  [CALLING_COMPONENT]: CALLING_REMOTE_COMPONENT_ID
};